export const programs = {
  paging: {
    total: 16,
    count: 10,
    totalPages: 2,
    currentPage: 0,
  },
  programs: [
    {
      programId: 'a5fda9aa-8940-433b-856f-7b46b80876a8',
      title: '1',
      shortDescription: 'Test Drew1',
      longDescription: 'test',
    },
    {
      programId: 'e516db5d-45f0-4c9e-a2b7-1f9723820c57',
      title: 'A CLover',
      shortDescription: 'A CLover',
      longDescription: 'A CLover',
    },
    {
      programId: '21504ab6-2ddc-456b-971f-2c6d965a40df',
      title: 'asdf',
      shortDescription: 'asdf',
      longDescription: 'asdf',
    },
    {
      programId: '6949066b-0d5a-4dc5-b93d-63b5effb4cd7',
      title: 'CloverProgramme',
      shortDescription: 'Clover Programme',
      longDescription: 'Clover Programme',
    },
    {
      programId: 'e5f826bd-6199-4ef6-835c-a8c0f5a9b861',
      title: 'First Program',
      shortDescription: 'First Program',
      longDescription: 'First Program',
    },
    {
      programId: 'ac0c6b8b-1231-476c-b65f-6c7d9320b899',
      title: 'Hello Program',
      shortDescription: 'hello',
      longDescription: 'N/A',
    },
    {
      programId: '73e9c8d5-6499-4c83-9401-f436c1df7963',
      title: 'HIT',
      shortDescription: 'Hit',
      longDescription: 'hit',
    },
    {
      programId: 'ec24357c-6131-4960-bdb0-0dc01c1548fc',
      title: 'Incentivio Testing',
      shortDescription: 'Incentivio Testing',
      longDescription: 'N/A',
    },
    {
      programId: 'd82ce5e2-3d9f-4ff8-bb2e-6d84c1aee599',
      title: 'LSPD',
      shortDescription: 'LSPD',
      longDescription: 'LSPD',
    },
    {
      programId: '7e2c00ea-64bd-4fc4-ac84-59e6852f767b',
      title: 'Message Test Program',
      shortDescription: 'Message Test Program',
      longDescription: 'N/A',
    },
  ],
};
